import {StyleSheet} from 'aphrodite';
import { colorThemes } from '../commonStyles';

const styles = StyleSheet.create({
    ErrorContainer:{
        position:'absolute',
        top:0,
        left:0,
        right:0,
        bottom:0,
        backgroundColor:colorThemes.blue,
        textAlign:'center',
        zIndex:13000,
        '@media (orientation:landscape)':{
            display:'none',
            pointerEvents:'none'
        }
    },
    logo:{
        position:'absolute',
        left:'2%',
        top:"1.5%",
        height:'5vh'
    },  
    animationContainer:{
        position:'relative',
        top:'35vh'
    },
    errorText:{
        color:'#FFAE47',
        fontFamily:'futura',
        fontSize:'3vh',
        width:'70vw',
        marginTop:'40vh',
        marginLeft:'15vw'
    }
})

export default styles;

